//pages

import {
  Dashboard,
  Provinces,
  District,
  Batch,
  Pou,
  Setting,
  AddProvince,
  EditProvince,
  DetailsProvince,
  DetailsDistrict,
  DetailsPou,
  IssuedBatch,
  IssuedbatchSecond,
  Seemore,
  Changepassword,
  CreateBatch,
  RequestBatch,
  Requests,
  RetireBatch,
  UnitsUsed,
  VaccineDetails,
  ReceiveInventory,
  NodeView,
} from "./pages";

import DetailsPage from "../../components/DetailsPage";
import Transactions from "../../components/BatchTransaction";
import BatchesOfChilds from "../../components/BatchesofChilds";
import childBatchDetails from "../../components/Details/Batch";

//routes

import { ministryRoutes, commonRoutes } from "../../Services/Routes/APP";

//admin routes export

export const ministryAdminRoutes = [
  {
    id: `ministry-122`,
    exact: false,
    path: ministryRoutes?.root,
    component: Dashboard,
  },
  {
    id: `ministry-123`,
    exact: false,
    path: ministryRoutes?.dashboard,
    component: Dashboard,
  },
  {
    id: `ministry-124`,
    exact: false,
    path: ministryRoutes?.provinces,
    component: Provinces,
  },
  {
    id: `ministry-125`,
    exact: false,
    path: ministryRoutes?.districts,
    component: District,
  },
  {
    id: `ministry-126`,
    exact: false,
    path: ministryRoutes?.pointOfUse,
    component: Pou,
  },
  {
    id: `ministry-123`,
    exact: false,
    path: ministryRoutes?.batch,
    component: Batch,
  },
  {
    id: `ministry-124`,
    exact: false,
    path: ministryRoutes?.setting,
    component: Setting,
  },
  {
    id: `ministry-125`,
    exact: false,
    path: ministryRoutes?.addProvince,
    component: AddProvince,
  },
  {
    id: `admin-126`,
    exact: false,
    path: ministryRoutes?.detailsProvince,
    component: DetailsProvince,
  },
  {
    id: `admin-127`,
    exact: false,
    path: ministryRoutes?.editProvince,
    component: EditProvince,
  },
  {
    id: `admin-128`,
    exact: false,
    path: ministryRoutes?.detailsDistrict,
    component: DetailsDistrict,
  },
  {
    id: `admin-139`,
    exact: false,
    path: ministryRoutes?.detailsPou,
    component: DetailsPou,
  },
  {
    id: `admin-129`,
    exact: false,
    path: ministryRoutes?.dashbordSeeMore,
    component: Seemore,
  },
  {
    id: `admin-130`,
    exact: false,
    path: ministryRoutes?.issuedBatch,
    component: IssuedBatch,
  },
  {
    id: `admin-130`,
    exact: false,
    path: ministryRoutes?.changePassword,
    component: Changepassword,
  },
  {
    id: `admin-131`,
    exact: false,
    path: ministryRoutes?.create_batch,
    component: CreateBatch,
  },
  {
    id: `admin-132`,
    exact: false,
    path: ministryRoutes?.request_inventory,
    component: RequestBatch,
  },
  {
    id: `admin-133`,
    exact: false,
    path: ministryRoutes?.requests,
    component: Requests,
  },
  {
    id: `admin-131`,
    exact: false,
    path: ministryRoutes?.retireBatch,
    component: RetireBatch,
  },
  {
    id: `admin-132`,
    exact: false,
    path: ministryRoutes?.units_used,
    component: UnitsUsed,
  },
  {
    id: `admin-133`,
    exact: false,
    path: ministryRoutes?.issuedBatchManually,
    component: IssuedbatchSecond,
  },
  {
    id: `admin-134`,
    exact: false,
    path: commonRoutes?.batch?.details,
    component: VaccineDetails,
  },
  {
    id: `admin-135`,
    exact: false,
    path: ministryRoutes?.receiveInventory,
    component: ReceiveInventory,
  },
  {
    id: `ministry-137`,
    exact: false,
    path: commonRoutes?.batch?.details,
    component: DetailsPage,
  },
  {
    id: `ministry-138`,
    exact: false,
    path: commonRoutes?.request + commonRoutes?.details,
    component: DetailsPage,
  },
  {
    id: `ministry-139`,
    exact: false,
    path: commonRoutes?.nodeView,
    component: NodeView,
  },
  {
    id: `ministry-140`,
    exact: false,
    path: commonRoutes?.node?.details,
    component: DetailsPage,
  },
  {
    id: "ministry-141",
    exact: false,
    path: commonRoutes?.transactions,
    component: Transactions,
  },
  {
    id: "ministry-142",
    exact: false,
    path: ministryRoutes?.districts + commonRoutes?.batches,
    component: BatchesOfChilds,
  },
  {
    id: "ministry-143",
    exact: false,
    path: ministryRoutes?.pointOfUse + commonRoutes?.batches,
    component: BatchesOfChilds,
  },
  {
    id: "ministry-144",
    exact: false,
    path: ministryRoutes?.provinces + commonRoutes?.batches,
    component: BatchesOfChilds,
  },
];
